var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotStartedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.09375C6.06294 2.09375 1.25 6.90669 1.25 12.8438C1.25 18.7808 6.06294 23.5938 12 23.5938C17.9371 23.5938 22.75 18.7808 22.75 12.8438C22.75 6.90669 17.9371 2.09375 12 2.09375ZM2.75 12.8438C2.75 7.73512 6.89137 3.59375 12 3.59375C17.1086 3.59375 21.25 7.73512 21.25 12.8438C21.25 17.9524 17.1086 22.0938 12 22.0938C6.89137 22.0938 2.75 17.9524 2.75 12.8438Z",
    fill: "#E48F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1316 13.8438C16.6112 13.8438 17 13.396 17 12.8438C17 12.2915 16.6112 11.8437 16.1316 11.8437L6.86842 11.8437C6.38881 11.8437 6 12.2915 6 12.8437C6 13.396 6.38881 13.8438 6.86842 13.8438L16.1316 13.8438Z",
    fill: "#E48F2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStartedIcon);
export default __webpack_public_path__ + "static/media/notStartedIcon.a0cd0a52cdedaf1d82dc54fb475a844a.svg";
export { ForwardRef as ReactComponent };